import { categories } from '@/mocks/resources';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/?search=${encodeURIComponent(searchQuery.trim())}`);
    }
    setSearchOpen(false);
    setSearchQuery('');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg group-hover:bg-primary-600 transition-colors">
              <i className="ri-stack-line text-lg text-white"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-900 whitespace-nowrap font-heading">
              老六资源库
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg text-foreground-600"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-200 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/70 shadow-sm animate-fade-in">
          <div className="px-4 md:px-6 py-3">
            <form onSubmit={handleSearch} className="flex items-center gap-3 max-w-2xl mx-auto">
              <i className="ri-search-line text-lg text-foreground-400"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索资源..."
                className="flex-1 bg-transparent text-sm text-foreground-800 placeholder-foreground-400 outline-none border-none"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setSearchOpen(false)}
                className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-200 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-foreground-500"></i>
              </button>
            </form>
          </div>
        </div>
      )}

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors"
            >
              关于我们
            </Link>
            <form onSubmit={(e) => { handleSearch(e); setMobileOpen(false); }} className="mt-2 px-4">
              <div className="flex items-center gap-2 bg-background-100 rounded-lg px-3 py-2">
                <i className="ri-search-line text-foreground-400"></i>
                <input
                  type="text"
                  placeholder="搜索资源..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="flex-1 bg-transparent text-sm text-foreground-800 placeholder-foreground-400 outline-none border-none"
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </nav>
  );
}